import ErrorLayout from '../../layouts/ErrorLayout'
import PageError from './PageError'

export default ErrorLayout(PageError)